export const FOLLOWUP_DOCUMENT_CHANNELS = Object.freeze([
  { value: 'email', label: 'E-mail', detail: 'Document joint à un message personnel.' },
  { value: 'hand_delivery', label: 'Remise en main propre', detail: 'Document remis pendant un rendez-vous.' },
  { value: 'post', label: 'Envoi postal', detail: 'Document imprimé puis envoyé par courrier.' },
]);

export function isDeliveryProofForSelection(proof, clientId, consultationId, channel) {
  const sha = (value) => /^[0-9a-f]{64}$/.test(String(value || ''));
  return Boolean(
    proof
    && proof.clientId === clientId
    && proof.consultationId === consultationId
    && sha(proof.contentSha256)
    && sha(proof.revisionSha256)
    && sha(proof.clientFormSha256)
    && sha(proof.artifactSha256)
    && FOLLOWUP_DOCUMENT_CHANNELS.some((item) => item.value === channel),
  );
}
